<template>
  <div class="yugao-item-container">
    <custom-router-link :item="info" class="yugao-item-link" :to="{name: 'YugaoDetails', params: {id: info.id}}" target="_blank">
      <div class="yugao-item-image">
        <el-image :src="projectFileUrl + info.image" fit="cover" v-if="info.image"></el-image>
        <el-image :src="require('@/assets/images/img3.png')" fit="cover" v-else></el-image>
      </div>
      <div class="yugao-item-details">
        <div class="yugao-item-title">{{info.name}}</div>
        <div class="yugao-item-summary" v-html="info.summary">
        </div>
      </div>
      <div class="yugao-item-more">
        <div class="yugao-item-publishtiem">{{info.publishTime && info.publishTime.split(" ")[0]}}</div>
        <div class="more-info">
          <span>阅读更多&nbsp;<i class="el-icon-right"></i></span>
        </div>
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.yugao-item-container {
  width: 100%;
  .yugao-item-link {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.08);
    .yugao-item-image {
      width: 100%;
      height: 400px;
      .el-image {
        width: 100%;
        height: 100%;
      }
    }
    .yugao-item-details {
      width: 100%;
      padding: 20px;
      .yugao-item-title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        height: 56px;
        margin-bottom: 10px;
        color: #212529;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .yugao-item-summary {
        font-size: 15px;
        color: #6c757d;
        white-space: pre-wrap; // 此活动预告模块有时间地点展示，需加此属性
      }
    }
    .yugao-item-more {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #6c757d;
    }
    .more-info {
      display: flex;
      font-size: 16px;
      color: #212529;
      line-height: 32px;
      span {
        border-bottom: 2px solid #2960a7;
        font-weight: 600;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .yugao-item-container {
    .yugao-item-link {
      box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.04);
      .yugao-item-image {
        width: 100%;
        height: auto;
        aspect-ratio: 0.75;
        overflow: hidden;
      }
      .yugao-item-details {
        padding: 14px;
        .yugao-item-title {
          font-size: 18px;
          line-height: 24px;
          height: 48px;
          margin-bottom: 6px;
        }
        .yugao-item-summary {
          font-size: 13px;
          color: #6c757d;
          white-space: pre-wrap; // 此活动预告模块有时间地点展示，需加此属性
        }
      }
      .yugao-item-more {
        padding: 14px;
        .yugao-item-publishtiem {
          font-size: 12px;
        }
      }
      .more-info {
        display: flex;
        font-size: 12px;
        color: #212529;
        line-height: 24px;
        span {
          border-bottom: 1px solid #2960a7;
          font-weight: 600;
        }
      }
    }
  }
}
</style>